import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
const CART_LINK = 'https://carlosponte.com/cart/add?id=56937498575173&quantity=1';
export function PricingSection() {
  const mainPackage = ['Acceso Instantáneo al Libro Principal con +50 recetas paso a paso, cantidades exactas, técnicas profesionales... (Valor: $38)', 'Membresía VIP de Por Vida — Actualizaciones y bonos mensuales sin cargos recurrentes (Valor: $18)', 'Certificado de Finalización personalizado con tu nombre', 'Descarga instantánea a celular, tablet o computador', 'Garantía 100% Libre de Riesgo'];
  const bonuses = ['Lista de Proveedores Por País (Valor: $18)', 'Libro Saponificación en Frío (Valor: $18)', 'Libro Moldes Caseros de Silicona (Valor: $18)', 'Libro Introducción a la Aromaterapia (Valor: $18)', 'Libro Cremas Faciales y Corporales (Valor: $18)', 'Libro Cuidado Natural de la Piel (Valor: $18)', 'Libro Estrategias de Venta (Valor: $27)', 'Libro Velas Artesanales Como Negocio (Valor: $18)'];
  return <section className="w-full py-16 md:py-24 px-4 bg-gradient-to-br from-cream to-white" data-id="element-95">
      <div className="max-w-4xl mx-auto" data-id="element-96">
        {/* Pricing Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-97">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-brown mb-6" data-id="element-98">
            Entonces María Alejandra, ¿Cuánto Cuesta Todo Esto?
          </h2>
          <p className="font-inter text-lg text-brown/80 max-w-2xl mx-auto leading-relaxed" data-id="element-99">
            Ahora, quizás pienses que una colección tan completa como esta será
            extremadamente cara... y la verdad, DEBERÍA serlo, considerando el
            inmenso valor que miles de alumnas satisfechas están obteniendo de
            este paquete.
          </p>
        </motion.div>

        {/* Main Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="bg-white rounded-2xl shadow-2xl border-4 border-terracotta/30 overflow-hidden mb-8" data-id="element-100">
          {/* Product Image */}
          <div className="bg-gradient-to-br from-terracotta via-sage to-gold p-12 text-center relative" data-id="element-101">
            <div className="absolute top-4 right-4 bg-urgency text-white rounded-full w-20 h-20 flex items-center justify-center shadow-xl transform rotate-12" data-id="element-102">
              <div className="text-center" data-id="element-103">
                <p className="font-montserrat font-bold text-xl" data-id="element-104">60%</p>
                <p className="font-inter text-xs" data-id="element-105">OFF</p>
              </div>
            </div>
            <div className="max-w-md mx-auto bg-white/10 backdrop-blur-sm rounded-xl p-8" data-id="element-106">
              <p className="font-playfair text-4xl font-bold text-white mb-2" data-id="element-107">
                Secretos de los Jabones
              </p>
              <p className="font-inter text-lg text-white/90" data-id="element-108">
                Paquete Completo + 9 Bonos
              </p>
            </div>
          </div>

          {/* Pricing Content */}
          <div className="p-8 md:p-12" data-id="element-109">
            {/* Price Display */}
            <div className="text-center mb-8" data-id="element-110">
              <p className="font-inter text-lg text-brown/70 mb-2" data-id="element-111">
                Así que para celebrar esta oferta especial... el precio será de
                solo:
              </p>
              <div className="flex items-center justify-center gap-4 mb-4" data-id="element-112">
                <span className="font-playfair text-4xl font-bold text-brown/40 line-through" data-id="element-113">
                  <PriceDisplay amount="37.97" data-id="element-114" />
                </span>
                <span className="font-playfair text-6xl md:text-7xl font-bold text-terracotta" data-id="element-115">
                  <PriceDisplay amount="9.97" data-id="element-116" />
                </span>
                <span className="font-inter text-2xl text-brown/70" data-id="element-117">USD</span>
              </div>
              <p className="font-montserrat font-bold text-2xl text-sage mb-4" data-id="element-118">
                ¡UN SOLO Y ÚNICO PAGO!
              </p>
              <p className="font-inter text-base text-brown/80 leading-relaxed max-w-2xl mx-auto" data-id="element-119">
                Así es. Tu inversión por TODO el paquete completo es de solo{' '}
                <PriceDisplay amount="9.97" className="font-bold text-terracotta" data-id="element-120" />{' '}
                USD. Eso es una vida entera de conocimiento en jabonería
                artesanal y negocio por el precio de un café con postre.
              </p>
            </div>

            {/* CTA Button */}
            <motion.a href={CART_LINK} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-gradient-to-r from-terracotta to-urgency text-white text-center py-6 px-8 rounded-xl font-montserrat font-bold text-xl md:text-2xl shadow-xl hover:shadow-2xl transition-shadow mb-6" aria-label="Descargar con 60% de descuento" data-id="element-121">
              ▶ DESCARGAR CON EL 60% DE DESCUENTO AHORA
            </motion.a>

            {/* Trust Elements */}
            <div className="space-y-3 mb-6" data-id="element-122">
              <div className="flex items-center justify-center gap-2 text-brown/70" data-id="element-123">
                <LockIcon className="w-5 h-5" data-id="element-124" />
                <span className="font-inter text-sm" data-id="element-125">
                  Este es un pago único. No hay cargos mensuales ni costos
                  ocultos.
                </span>
              </div>
              <div className="flex items-center justify-center gap-2 text-brown/70" data-id="element-126">
                <ShieldCheckIcon className="w-5 h-5" data-id="element-127" />
                <span className="font-inter text-sm" data-id="element-128">
                  Me reservo el derecho de finalizar este descuento en cualquier
                  momento sin previo aviso.
                </span>
              </div>
            </div>

            {/* Scarcity Counter */}
            <div className="bg-urgency/10 border-2 border-urgency/30 rounded-lg p-4 text-center mb-8" data-id="element-129">
              <p className="font-montserrat font-bold text-lg text-urgency" data-id="element-130">
                43 Libros Vendidos — ¡Solo Quedan 7 Copias en Promoción!
              </p>
            </div>

            {/* Payment Logos */}
            <div className="flex items-center justify-center gap-4 mb-8 flex-wrap" data-id="element-131">
              <CreditCardIcon className="w-8 h-8 text-brown/40" data-id="element-132" />
              <span className="font-inter text-sm text-brown/60" data-id="element-133">
                Pago Seguro Protegido por Hotmart
              </span>
            </div>

            {/* What's Included */}
            <div className="border-t border-brown/10 pt-8" data-id="element-134">
              <h3 className="font-playfair text-2xl font-bold text-brown mb-6 text-center" data-id="element-135">
                Aquí Tienes TODO Lo Que Recibirás:
              </h3>

              {/* Main Package */}
              <div className="mb-6" data-id="element-136">
                <h4 className="font-inter font-bold text-lg text-brown mb-3" data-id="element-137">
                  Paquete Completo Oficial de "Secretos de los Jabones"
                </h4>
                <div className="space-y-2" data-id="element-138">
                  {mainPackage.map((item, index) => <div key={index} className="flex items-start gap-2" data-id="element-139">
                      <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-140" />
                      <span className="font-inter text-sm text-brown/80" data-id="element-141">
                        {item}
                      </span>
                    </div>)}
                </div>
              </div>

              {/* Bonuses */}
              <div data-id="element-142">
                <h4 className="font-inter font-bold text-lg text-brown mb-3" data-id="element-143">
                  Más Estos Bonos Increíbles:
                </h4>
                <div className="space-y-2" data-id="element-144">
                  {bonuses.map((bonus, index) => <div key={index} className="flex items-start gap-2" data-id="element-145">
                      <CheckCircleIcon className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" data-id="element-146" />
                      <span className="font-inter text-sm text-brown/80" data-id="element-147">
                        {bonus}
                      </span>
                    </div>)}
                </div>
              </div>
            </div>

            {/* Value Summary */}
            <div className="mt-8 bg-gradient-to-r from-sage/10 to-terracotta/10 p-6 rounded-xl text-center" data-id="element-148">
              <p className="font-inter text-lg text-brown/80 mb-2" data-id="element-149">
                Valor Total:
              </p>
              <p className="font-playfair text-4xl font-bold text-brown/60 line-through mb-2" data-id="element-150">
                <PriceDisplay amount="209" data-id="element-151" />+ USD
              </p>
              <p className="font-inter text-lg text-brown/80 mb-2" data-id="element-152">
                Accede Hoy Por Un Único Pago De:
              </p>
              <p className="font-playfair text-5xl font-bold text-terracotta" data-id="element-153">
                <PriceDisplay amount="9.97" data-id="element-154" /> USD
              </p>
            </div>

            {/* Final CTA */}
            <motion.a href={CART_LINK} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-gradient-to-r from-sage to-terracotta text-white text-center py-6 px-8 rounded-xl font-montserrat font-bold text-xl md:text-2xl shadow-xl hover:shadow-2xl transition-shadow mt-8" aria-label="Descargar ahora con descuento" data-id="element-155">
              ▶ SÍ, QUIERO ACCEDER AHORA
            </motion.a>
          </div>
        </motion.div>

        {/* Guarantee Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="bg-white rounded-xl shadow-lg p-8 md:p-12 border-2 border-sage/30" data-id="element-156">
          <div className="text-center mb-6" data-id="element-157">
            <ShieldCheckIcon className="w-16 h-16 text-sage mx-auto mb-4" data-id="element-158" />
            <h3 className="font-playfair text-3xl font-bold text-brown mb-4" data-id="element-159">
              Mi Garantía de 7 Días "ÁMALO O DÉJALO"
            </h3>
            <p className="font-montserrat font-bold text-xl text-sage mb-4" data-id="element-160">
              ¡100% de Satisfacción Garantizada!
            </p>
          </div>
          <p className="font-inter text-lg text-brown/90 leading-relaxed text-center max-w-2xl mx-auto" data-id="element-161">
            Si este no es el recurso de jabonería artesanal más completo que
            hayas visto en tu vida, simplemente envíame un correo electrónico y
            te devuelvo el 100% de tu dinero. Sin preguntas. Sin letra pequeña.
            Sin historias.
          </p>
          <p className="font-inter text-base text-brown/70 text-center mt-4" data-id="element-162">
            Tu compra está además protegida por Hotmart, empresa líder dedicada
            a la educación en línea y venta de productos digitales desde 2011.
            Puedes confiar al 100%.
          </p>
        </motion.div>
      </div>
    </section>;
}